import { useNotification } from '../../../../hooks'

import { isTableRefreshed } from './useTableRefresh.utils'

export function useTableRefresh({ isRefetching, onReload }) {
  const { handleAddSuccessNotification } = useNotification()

  function handleRefresh() {
    onReload().then(result => {
      if (isTableRefreshed(result)) {
        handleAddSuccessNotification('Notification.CommonTitleRefreshedKey')
      }
    })
  }

  // The disabled button also loses focus, so a held Enter cannot stack reloads.
  return {
    refreshButtonProps: { isLoading: isRefetching, onClick: handleRefresh },
  }
}
